import { Stack, Typography } from '@locus-taxy/disco-ui';

interface ProfileViewFieldProps {
  label: string;
  value: string | null | undefined;
}

/**
 * ProfileViewField — reusable label/value display pair for view mode.
 */
export function ProfileViewField({
  label,
  value,
}: Readonly<ProfileViewFieldProps>) {
  return (
    <Stack direction="column" gap={1} className="flex-1">
      <Typography variant="body2" fontWeight="medium" color="muted">
        {label}
      </Typography>
      <Typography variant="body1">{value ?? '—'}</Typography>
    </Stack>
  );
}
